function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import { AxisLeft, AxisRight } from '@vx/axis';
import { axisStylesShape, tickStylesShape } from '../utils/propShapes';
var propTypes = {
  axisStyles: axisStylesShape,
  hideZero: PropTypes.bool,
  label: PropTypes.string,
  labelProps: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  labelOffset: PropTypes.number,
  numTicks: PropTypes.number,
  orientation: PropTypes.oneOf(['left', 'right']),
  rangePadding: PropTypes.number,
  tickComponent: PropTypes.func,
  tickStyles: tickStylesShape,
  tickLabelProps: PropTypes.func,
  tickFormat: PropTypes.func,
  tickValues: PropTypes.arrayOf( // number or date/moment object
  PropTypes.oneOfType([PropTypes.number, PropTypes.object, PropTypes.string])),
  // probably injected by parent
  innerWidth: PropTypes.number,
  height: PropTypes.number,
  scale: PropTypes.func
};
var defaultProps = {
  axisStyles: {},
  hideZero: false,
  innerWidth: null,
  height: null,
  label: null,
  labelProps: null,
  labelOffset: undefined,
  numTicks: null,
  orientation: 'right',
  rangePadding: null,
  scale: null,
  tickComponent: null,
  tickFormat: null,
  tickLabelProps: null,
  tickStyles: {},
  tickValues: undefined
};

var YAxis =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(YAxis, _React$PureComponent);

  function YAxis() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = YAxis.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        axisStyles = _this$props.axisStyles,
        hideZero = _this$props.hideZero,
        innerWidth = _this$props.innerWidth,
        height = _this$props.height,
        label = _this$props.label,
        labelProps = _this$props.labelProps,
        labelOffset = _this$props.labelOffset,
        numTicks = _this$props.numTicks,
        orientation = _this$props.orientation,
        rangePadding = _this$props.rangePadding,
        scale = _this$props.scale,
        tickComponent = _this$props.tickComponent,
        tickFormat = _this$props.tickFormat,
        passedTickLabelProps = _this$props.tickLabelProps,
        tickStyles = _this$props.tickStyles,
        tickValues = _this$props.tickValues;
    if (!scale || !innerWidth) return null;
    var Axis = orientation === 'left' ? AxisLeft : AxisRight;
    var tickLabelProps = passedTickLabelProps;

    if (!tickLabelProps) {
      tickLabelProps = tickStyles.label && tickStyles.label[orientation] ? function () {
        return tickStyles.label[orientation];
      } : undefined;
    }

    return React.createElement(Axis, {
      top: 0,
      left: orientation === 'right' ? innerWidth : 0,
      rangePadding: rangePadding,
      hideTicks: numTicks === 0,
      hideZero: hideZero,
      label: label,
      labelProps: _extends({
        verticalAnchor: 'start',
        width: Math.max.apply(Math, scale.range().concat([height || 0]))
      }, labelProps || (axisStyles.label || {})[orientation]),
      labelOffset: labelOffset,
      numTicks: numTicks,
      scale: scale,
      stroke: axisStyles.stroke,
      strokeWidth: axisStyles.strokeWidth,
      tickComponent: tickComponent,
      tickFormat: tickFormat,
      tickLabelProps: tickLabelProps,
      tickLength: tickStyles.tickLength,
      tickStroke: tickStyles.stroke,
      tickValues: tickValues
    });
  };

  return YAxis;
}(React.PureComponent);

export { YAxis as default };
YAxis.propTypes = propTypes;
YAxis.defaultProps = defaultProps;
YAxis.displayName = 'YAxis';